import React, { useEffect, useState } from "react";
import { Table, message, Popconfirm ,Modal} from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import SummaryApi from "../../../common/index";

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axios.get(SummaryApi.getAllUsers.url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
          "Content-Type": "application/json",
        },
      });

      if (response.data.success) setUsers(response.data.users);
      else message.error("Failed to fetch users");
    } catch {
      message.error("Error fetching users");
    } finally {
      setLoading(false);
    }
  };

 const handleDelete = async (id) => {
  Modal.confirm({
    title: "Are you sure you want to delete this user?",
    okText: "Yes",
    okType: "danger",
    cancelText: "No",
    onOk: async () => {
      try {
        const response = await axios.delete(SummaryApi.deleteUser.url(id), {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
          },
        });

        if (response.data.success) {
          message.success("User deleted successfully");
          fetchUsers(); // Refresh table
        } else {
          message.error(response.data.message || "Failed to delete user");
        }
      } catch (error) {
        console.error("Delete error:", error);
        message.error("Failed to delete user");
      }
    },
  });
};


  useEffect(() => {
    fetchUsers();
  }, []);

  const columns = [
    { title: "ID", dataIndex: "id", key: "id", width: 60 },
  { title: "Name", dataIndex: "name", key: "name" },
  { title: "Email", dataIndex: "email", key: "email" },
  { title: "Mobile", dataIndex: "mobile", key: "mobile" },
  { title: "Address", dataIndex: "address", key: "address" },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "15px", fontSize: "18px" }}>
          <EyeOutlined
            style={{ color: "#1890ff", cursor: "pointer" }}
            onClick={() => navigate(`/admin/dashboard/users/${record.id}`)}
          />
          <Popconfirm
            title="Are you sure you want to delete this user?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined style={{ color: "red", cursor: "pointer" }} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div className="p-4">
      <h2>Manage Users</h2>
      <Table
        columns={columns}
        dataSource={users}
        rowKey="id"
        loading={loading}
        bordered
        pagination={{ pageSize: 8 }}
      />
    </div>
  );
};

export default AdminUsers;
